module.exports = __webpack_public_path__ + "static/tr-finans-3-8dd0ce68334861782494a7a9bd2f20b3.png";